import * as React from 'react';

import { Text } from '@lightspeed/flame/Text';

interface Props {}

const SectionTitle: React.FC<Props> = ({ children }) => {
  return (
    <Text
      size="small"
      fontWeight="700"
      style={{ flex: 1, textTransform: 'uppercase', letterSpacing: '1.5px', fontSize: 12 }}
    >
      {children}
    </Text>
  );
};

export default SectionTitle;
